import _, { capitalize, pick } from 'lodash'
import { v4 as uuid } from 'uuid'
import { List } from 'immutable'
import { option } from '../lib/common'
import { getValueForMode, LAYOUT_MODE } from './toUnits'
import { WIDGET_TYPES } from './WIDGET_TYPES'
import { getSizeProp } from './getStyle'
import { shallowEqual } from 'react-redux'

export const findMaxProjectID = (project, pages) => {
  let maxID = _.get(project, ['Settings', 'lastID'], 0)
  _.each(_.get(project, 'Pages', []), (page) => {
    if (/^p[0-9]*$/.test(page.uid)) {
      const id = parseInt(String(page.uid).replace('p', ''), 10)
      maxID = _.max([id, maxID])
    }
  })
  _.each(pages, (page) => {
    _.each(_.get(page, 'Props.elements', {}), (elem, uid) => {
      if (/^[a-z]*([0-9]*)$/.test(uid)) {
        const id = parseInt(String(uid).replace(/^[a-z]*([0-9]*)$/, '$1'), 10)
        maxID = _.max([id, maxID])
      }
    })
  })
  return maxID
}

export function getRecursiveParentPos(elements, uid, retState, path, isRTL) {
  let result = 0
  let resultTop = 0
  const elem = _.find(elements, (v) => v.uid === uid)
  if (!elem) {
    return {
      left: 0,
      shift: 0,
      right: 0,
      width: 0,
      shiftRight: 0,
      parentWidth: 0,
      top: 0,
      shiftTop: 0,
      parentTop: 0,
      parentHeight: 0,
    }
  }
  let key = 'left'
  if (isRTL) {
    key = 'right'
  }
  result += elem[key]
  resultTop += elem.top

  let parentLeft = 0,
    parentRight = 0,
    parentWidth = 0
  let parentTop = 0,
    parentHeight = 0
  let parent = retState.getIn([...path, 'elements', uid, 'parent'], '')
  if (parent) {
    let parentPos = getRecursiveParentPos(elements, parent, retState, path, isRTL)
    parentLeft = parentPos.left
    parentRight = parentPos.right
    parentWidth = parentPos.width
    parentTop = parentPos.top
    parentHeight = parentPos.height
  }
  result += parentLeft
  resultTop += parentTop

  return {
    right: result + elem.width,
    bottom: resultTop + elem.height,
    height: elem.height,
    width: elem.width,
    parentWidth: parentWidth,
    parentUID: parent,
    left: result,
    shift: parentLeft,
    shiftRight: parentRight,
    top: resultTop,
    shiftTop: parentTop,
    parentHeight,
  }
}

export function getDefaultLinks(page) {
  return {
    Type: 'PAGE',
    href: page.get('uid'),
    id: uuid(),
    Text: page.get('name', 'No name'),
  }
}

export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

export const FONT_CONST = [
  'fontSize',
  'fontWeight',
  'fontFamily',
  'color',
  'textAlign',
  'fontStyle',
  'textDecoration',
  'lineHeight',
  'letterSpacing',
  'color',
]

export const TABLE_ACTION_VARIANTS = [option('Button', 'button'), option('Icon', 'icon')]

export const PREFIX_INPUTS = [
  'all',
  'text',
  'url',
  'number',
  'lookup',
  'textarea',
  'date',
  'time',
  'datetime',
  'currency',
]
export const SUFFIX_INPUTS = ['all', 'text', 'url', 'number', 'textarea', 'currency', 'daterange']

export const STATE_CLASSES = [
  'buttonContinue',
  'button',
  'bottomLink',
  'Item',
  'link',
  'signInLink',
  'profileLink',
  'profileMenuLink',
  'cancel',
  'apply',
  'Button',
  'primary',
  'secondary',
]
export const STATE_CLASSES_ROOT_CLASS = ['Button', 'Link']

export const AreaRegExp = /^[a-z]*[a-z0-9_]*$/i

export const PLACEHOLDER_FOR_COMPONENTS = [
  'Strip',
  'ECommerceCatalogue_Default',
  'ECommerceCatalogue_Narrow',
  'ECommerceProduct',
]

export const notCheckChildren = ({ children: childLeft, ...left }, { children: childRight, ...right }) =>
  shallowEqual(left, right)

export const STRIP_CATEGORIES = ['Popular', 'Hero', 'Services', 'Contact Us', 'General', 'My Strips']

export const TYPO_ELEMS = ['Typography', ..._.times(6, (n) => `typo_h${n + 1}`), 'typo_p', 'typo_pre', 'typo_html']

export const isWidgetType = (type) =>
  WIDGET_TYPES.indexOf(type) !== -1 || type == 'ImageChoice' || type == 'galleryCarousel'

export const getBorderStyle = (style) => {
  return _.get(style, 'borderWidth')
    ? `${getSizeProp(style, 'borderWidth')} ${_.get(style, 'borderStyle', 'none')} ${_.get(style, 'borderColor', '#000')}`
    : ''
}

const stylesToCheck = [
  'lineHeight',
  'height',
  'minHeight',
  'maxHeight',
  'width',
  'minWidth',
  'maxWidth',
  'paddingRight',
  'paddingLeft',
  'paddingBottom',
  'paddingTop',
  'marginRight',
  'marginTop',
  'marginLeft',
  'marginBottom',
  'flexBasis',
  'borderWidth',
]
export const filterUnsetStyles = (styles) =>
  _.reduce(
    styles,
    (ret, val, key) => {
      const indexRes = stylesToCheck.indexOf(key)
      if (indexRes !== -1 && typeof val !== 'undefined' && val !== '') {
        return {
          ...ret,
          [key]: val,
        }
      } else if (indexRes !== -1) {
        return ret
      } else {
        return {
          ...ret,
          [key]: val,
        }
      }
    },
    {}
  )

export const round = (num) => {
  try {
    return Number(num).toFixed(2)
  } catch (error) {
    return num
  }
}

export function num2chars(num, upper) {
  num2chars.letters = num2chars.letters || 'abcdefghijklmnopqrstuvwxyz'.split('')
  var ret = repeat(num2chars.letters[num % 26], Math.floor(num / 26), num)
  function repeat(chr, n, num) {
    if (n < 1 && num < 26) {
      return chr
    }
    return new Array(n + 2).join(chr)
  }
  return upper ? ret.toUpperCase() : ret
}

export const getStyleForMode = (styles, mode, preKey, key, defaultVal, xsDefVal) => {
  return styles.getIn([...preKey, mode, ...key], defaultVal)
}

export const getThemePathForComponent = (element, layoutMode, path) => {
  if (path != 'root' && path !== 'rootHover' && path !== 'rootActive' && path !== 'rootSelected') {
    return path
  }

  let variant = getVariantForComponent(element, layoutMode)
  if (variant && element.get('type') !== 'Link') {
    if (String(path).indexOf('Hover') !== -1 || String(path).indexOf('Active') !== -1) {
      return variant + String(path).replace('root', '')
    } else {
      return variant
    }
  }

  return path
}

export const getVariantForComponent = (element, layoutMode) => {
  let variant
  switch (element.get('type')) {
    case 'Typography':
      variant = getValueForMode(element, layoutMode, ['props'], ['variant'], 'p')
      break
    case 'Button':
      variant = getValueForMode(element, layoutMode, ['props'], ['variant'], 'primary')
      break
    case 'Svg':
      variant = String(element.getIn(['props', 'subType'], 'shape')).toLowerCase()
      break
    case 'Link':
      variant = 'a'
      break
  }
  return variant
}

export const getUniqueAreaName = (area) => {
  let maxAreaNumber = 0
  _.each(area, function (row) {
    _.each(row, function (areaName) {
      if (String(areaName).toLowerCase().indexOf('col') === 0) {
        let num = parseInt(String(areaName).toLowerCase().replace('col', ''))
        if (num > maxAreaNumber) {
          maxAreaNumber = num
        }
      }
    })
  })
  maxAreaNumber++
  return 'Col' + maxAreaNumber
}

export const getDefaultAreasState = (cols, rows, areas) => {
  let newArea = []
  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      if (!newArea[i]) {
        newArea[i] = []
      }
      if (_.get(areas, [i, j])) {
        newArea[i][j] = _.get(areas, [i, j])
      } else {
        newArea[i][j] = getUniqueAreaName(areas.concat(newArea))
      }
    }
  }
  return newArea
}

// export const getDefaultGrid = (rows = 3, cols = 3, area, parent = null) => {
//   const uid = uuid()
//   let grid = {
//     type: 'Strip',
//     props: {
//       styleRef: uid
//     },
//     children: [],
//     parent: parent
//   }
//   let elements = {
//     [uid]: grid
//   }
//   let styles = {
//     [uid]: {
//       lg: {
//         columns: cols,
//         rows: rows,
//         areas: area
//       }
//     }
//   }
//   return { elements, uid, styles };
// }

export const hideUntilLG = (elements, layoutMode, elemUID, configuredDevices) => {
  _.each(LAYOUT_MODE, function (key) {
    if (key == 'lg' || (configuredDevices && configuredDevices.get(key))) {
      if (!_.get(elements, [elemUID, 'props', key])) {
        _.set(elements, [elemUID, 'props', key], {})
      }
      if (layoutMode != key) {
        _.set(elements, [elemUID, 'props', key, 'isHidden'], true)
      } else {
        _.set(elements, [elemUID, 'props', key, 'isHidden'], false)
      }
    }
  })
  return elements
}

export const SIZE_KEYS = [
  'minWidth',
  'minWidthUnit',
  'maxWidth',
  'maxWidthUnit',
  'minHeight',
  'maxHeight',
  'minHeightUnit',
  'maxHeightUnit',
]
export const ALL_SIZE_KEYS = ['width', 'widthUnit', 'height', 'heightUnit', ...SIZE_KEYS]
export const ALL_SIZE_KEYS_WITH_FONT = [
  ...ALL_SIZE_KEYS,
  'fontSize',
  'paddingLeft',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'top',
  'left',
  'bottom',
  'right',
  'topUnit',
  'leftUnit',
  'bottomUnit',
  'rightUnit',
  'height',
  'columns',
  'rows',
  'areas',
  'lineHeight',
]
export const ALL_SIZE_KEYS_NO_UNIT = ['width', 'height', 'minWidth', 'maxWidth', 'minHeight', 'maxHeight']

export const getIsMobileDevice = (layoutMode) => {
  return layoutMode === 'xs' || layoutMode === 'ss' || layoutMode === 'sm'
}

export const getAreasList = (areas, layoutMode) => {
  let stripAreas = []
  if (getIsMobileDevice(layoutMode)) {
    let localAreas = areas.toJS()
    _.each(localAreas, function (row, rowIndex) {
      stripAreas = stripAreas.concat(row)
    })
  } else {
    stripAreas = areas.get(0, List()).toJS()
  }
  return stripAreas
}

export const processKeys = ['Header', 'Drawer', 'Footer']
export const getDefaultRefs = (defObject = null) =>
  _.fromPairs(
    _.map(
      _.times(3, () => ({
        object: defObject,
        field: { key: null },
        polymorphic: false,
        relationshipName: '',
        type: '',
      })),
      (r, i) => [i, r]
    )
  )

export const applyFontStyleToElem = (to, from) => {
  let ret = {
    ...to,
  }
  _.each(LAYOUT_MODE, (mode) => {
    _.each(['fontSize'], (key) => {
      let val = _.get(from, [mode, 'root', key])
      if (typeof val !== 'undefined') {
        _.set(ret, [mode, 'root', key], val)
      }
      val = _.get(from, [mode, 'root', `${key}Unit`])
      if (typeof val !== 'undefined') {
        _.set(ret, [mode, 'root', `${key}Unit`], val)
      }
    })
  })
  return ret
}

export const getConfiguredMode = (confDev, mode) => {
  let confMode = mode
  for (let i = LAYOUT_MODE.indexOf(confMode); i >= 0; i--) {
    if (confDev[LAYOUT_MODE[i]]) {
      return LAYOUT_MODE[i]
    }
  }
  return mode
}

export const fixPageUIDElem = (value, pageUID) => {
  let val = String(value)
  if (val.indexOf(':') === -1) {
    return String(value)
  }
  val = val.split(':')
  val[0] = pageUID
  return val.join(':')
}

export const updateValueRulesMetaData = (elem, key, root, pageUID) => {
  if (!elem) {
    return elem
  }
  try {
    if (_.get(elem, ['props', 'valueRule'])) {
      _.each(_.get(elem, ['props', 'valueRule']), function (rule) {
        if (rule && rule.conditions) {
          _.each(rule.conditions, function (cond) {
            if (String(cond?.field?.value).indexOf(key) !== -1) {
              cond.field.value = fixPageUIDElem(cond?.field?.value, pageUID).replace(key, root)
              cond.field.uid = root
            }
          })
        }
      })
    }
  } catch (err) {
    console.error('err >>> ', err)
  }
  return elem
}

export const updateRulesMetaData = (rules, key, root, pageUID) => {
  if (!rules) {
    return {}
  }
  _.each(rules, (ruleSet) => {
    _.each(ruleSet, (rule) => {
      const actions = _.omitBy(rule.actions, (v, k) => String(k).indexOf(key) === -1)
      const pickActions = _.pickBy(rule.actions, (v, k) => String(k).indexOf(key) === -1)
      rule.actions = {
        ...pickActions,
      }
      _.each(actions, (action, actionKey) => {
        let nextKey = fixPageUIDElem(actionKey, pageUID).replace(key, root)
        rule.actions[nextKey] = action
      })
      _.each(rule.conditions, (cond) => {
        if (cond.valueType === 'field') {
          if (String(cond.value.value).indexOf(key) !== -1) {
            cond.value.value = fixPageUIDElem(cond.value.value, pageUID).replace(key, root)
            cond.value.uid = root
          }
        }
        if (String(cond?.field?.value).indexOf(key) !== -1) {
          cond.field.value = fixPageUIDElem(cond?.field?.value, pageUID).replace(key, root)
          cond.field.uid = root
        }
      })
    })
  })

  let rule = _.find(rules, (v, k) => {
    const [, u] = String(k).split(':')
    return u === key
  })
  const isHaveRule = Boolean(rule)
  if (!isHaveRule) {
    rule = rules[key]
  }

  if (Boolean(rule)) {
    let retRules = {
      ..._.omitBy(rules, (v, k) => {
        if (k !== key || String(k).indexOf(key) === -1) {
          return true
        } else {
          return false
        }
      }),
    }
    _.each(rule, (v, k) => {
      v.uid = uuid()
      const [, uid, ...ret] = String(k).split(':')
      let newActions = {}
      _.each(v.actions, (action, actionKey) => {
        let nextKey = String(actionKey)
        if (String(actionKey).indexOf(key) !== -1) {
          nextKey = fixPageUIDElem(actionKey, pageUID).replace(key, root)
        }
        newActions = {
          ...newActions,
          [nextKey]: action,
        }
      })
      v.actions = newActions
      _.each(v.conditions, (cond) => {
        if (cond.valueType === 'field') {
          if (uid && String(cond.value.value).indexOf(uid) !== -1) {
            cond.value.value = fixPageUIDElem(cond.value.value, pageUID).replace(key, root)
            cond.value.uid = root
          }
        }
        if (uid && String(cond?.field?.value).indexOf(uid) !== -1) {
          cond.field.value = fixPageUIDElem(cond?.field?.value, pageUID).replace(key, root)
          cond.field.uid = root
        }
      })

      let elemKey = [pageUID, root].join(':')
      let elemRules = rules[elemKey] || []
      elemRules.push(v)

      retRules = {
        ...retRules,
        [elemKey]: elemRules,
      }
      rules[elemKey] = elemRules
    })
    return retRules
  } else {
    return rules
  }
}

export const displayPrintableFont = (font) => {
  let fonts = String(font).split(',')
  return _.trim(_.first(fonts), '"\'')
}

export const getElementVariants = (type) => {
  switch (type) {
    case 'Link':
      return ['a']
    case 'Svg':
      return ['shape', 'icon']
    case 'Button':
      return ['root', 'primary', 'secondary']
    case 'Typography':
      return ['title', 'h1', 'subhead', 'p', 'caption']
    default:
      return []
  }
}

export function addAlpha(originalColor, alpha = 1) {
  let alphaFixed = Math.round(alpha * 255)
  let alphaHex = Number(alphaFixed).toString(16)
  if (alphaHex.length == 1) {
    alphaHex = '0' + alphaHex
  }
  return `${_.trim(originalColor)}${alphaHex}`
}

const HEX_RE = /^[a-f0-9]{3}|[a-f0-9]{6}|[a-f0-9]{8}$/i

export function hexToRgba(hex) {
  if (hex === null || hex === undefined) {
    hex = ''
  }
  if (!HEX_RE.test(hex)) {
    return hex
  }
  if (!hex) {
    return ''
  }
  hex = String(hex)
  var bigint, r, g, b, a
  //Remove # character
  var re = /^#?/
  var aRgb = hex.replace(re, '')
  if (aRgb.length == 3) {
    bigint = parseInt(aRgb, 16)
    r = (bigint >> 4) & 255
    g = (bigint >> 2) & 255
    b = bigint & 255
    return 'rgba(' + r + ',' + g + ',' + b + ',1)'
  }
  if (aRgb.length == 6) {
    bigint = parseInt(aRgb, 16)
    r = (bigint >> 16) & 255
    g = (bigint >> 8) & 255
    b = bigint & 255
    return 'rgba(' + r + ',' + g + ',' + b + ',1)'
  }
  if (aRgb.length == 8) {
    bigint = parseInt(aRgb, 16)
    r = (bigint >> 24) & 255
    g = (bigint >> 16) & 255
    b = (bigint >> 8) & 255
    a = (bigint & 255) / 255
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a.toFixed(1) + ')'
  }
}

export function collectStyleCustomFonts(styles) {
  const fonts = []
  _.each(styles, (style) => {
    _.each(LAYOUT_MODE, (mode) => {
      let elStyle = _.get(style, [mode], {})
      _.each(elStyle, (v, k) => {
        if (_.has(v, ['fontFamily'])) {
          fonts.push(_.get(v, ['fontFamily']))
        }
      })
    })
  })
  return _.compact(_.uniq(fonts))
}
export const THEME_KEEP_PROPS = [
  'PageConditionalForm',
  'EmailSurvey',
  'lg',
  'Type',
  'fontFamily',
  'primary',
  'color',
  'secondary',
  'backgroundColor',
  'page404',
  'page403',
  'FormField',
]
